'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var Alert = require('../Alert/Alert.js');
var AlertDescription = require('../Alert/AlertDescription.js');
var AlertIcon = require('../Alert/AlertIcon.js');
var AlertTitle = require('../Alert/AlertTitle.js');
require('../Alert/alertContext.js');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var CloseButton = require('../CloseButton/CloseButton.js');
var toast_placement = require('./toast.placement.js');
var toast_store = require('./toast.store.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
// Chakra overwrite: Deep adaption including defaults as well as the whole rendering of 'Alert'.
/**
 * The `Toast` component is used to give feedback to users after an action has taken place.
 *
 * @see Docs https://chakra-ui.com/docs/components/toast
 */
var Toast = function Toast(props) {
  var status = props.status,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'solid' : _props$variant,
    id = props.id,
    title = props.title,
    _props$isClosable = props.isClosable,
    isClosable = _props$isClosable === void 0 ? true : _props$isClosable,
    onClose = props.onClose,
    description = props.description,
    icon = props.icon;
  var ids = id ? {
    root: "toast-".concat(id),
    title: "toast-".concat(id, "-title"),
    description: "toast-".concat(id, "-description")
  } : undefined;
  return /*#__PURE__*/(
    // Chakra overwrite: changed whole Alert
    React__default["default"].createElement(Alert.Alert, {
      status: status
      // `Toast` uses a black `colorScheme` for `info` instead of `blue`.
      // To not have to override the `colorScheme` for `info` in the `Alert` globally,
      // we do it here.
      ,

      colorScheme: status === 'info' ? 'blue' : null,
      variant: variant,
      id: ids === null || ids === void 0 ? void 0 : ids.root,
      boxShadow: "md",
      width: "auto",
      position: "relative",
      p: {
        base: '2',
        sm: 4
      },
      minWidth: {
        lg: 400
      },
      "aria-labelledby": ids === null || ids === void 0 ? void 0 : ids.title
    }, icon && /*#__PURE__*/React__default["default"].createElement(AlertIcon.AlertIcon, null, icon), /*#__PURE__*/React__default["default"].createElement(AlertDescription.AlertDescription, {
      id: ids === null || ids === void 0 ? void 0 : ids.description
    }, title && /*#__PURE__*/React__default["default"].createElement(AlertTitle.AlertTitle, {
      id: ids === null || ids === void 0 ? void 0 : ids.title
    }, title), description), /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
      flex: "1",
      maxWidth: "100%"
    }), isClosable && /*#__PURE__*/React__default["default"].createElement(CloseButton.CloseButton, {
      size: "sm",
      onClick: onClose,
      sx: description && {
        marginBottom: 'auto'
      }
    }))
  );
};
function createRenderToast() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var render = options.render,
    _options$toastCompone = options.toastComponent,
    ToastComponent = _options$toastCompone === void 0 ? Toast : _options$toastCompone;
  var renderToast = function renderToast(props) {
    if (typeof render === 'function') {
      return render(_objectSpread(_objectSpread({}, props), options));
    }
    return /*#__PURE__*/React__default["default"].createElement(ToastComponent, _extends__default["default"]({}, props, options));
  };
  return renderToast;
}
function createToastFn(dir, defaultOptions) {
  var normalizeToastOptions = function normalizeToastOptions(options) {
    var _options$position;
    return _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), options), {}, {
      position: toast_placement.getToastPlacement((_options$position = options === null || options === void 0 ? void 0 : options.position) !== null && _options$position !== void 0 ? _options$position : defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.position, dir)
    });
  };
  var toast = function toast(options) {
    var normalizedToastOptions = normalizeToastOptions(options);
    var Message = createRenderToast(normalizedToastOptions);
    return toast_store.toastStore.notify(Message, normalizedToastOptions);
  };
  toast.update = function (id, options) {
    toast_store.toastStore.update(id, normalizeToastOptions(options));
  };

  // Chakra overwrite: removed generalized type of 'Result'
  toast.promise = function (promise, options) {
    var id = toast(_objectSpread(_objectSpread({}, options.loading), {}, {
      status: 'loading',
      duration: null
    }));
    promise.then(function (data) {
      return toast.update(id, _objectSpread({
        status: 'success',
        duration: 5000
      }, utils.runIfFn(options.success, data)));
    })["catch"](function (error) {
      return toast.update(id, _objectSpread({
        status: 'error',
        duration: 5000
      }, utils.runIfFn(options.error, error)));
    });
  };
  toast.closeAll = toast_store.toastStore.closeAll;
  toast.close = toast_store.toastStore.close;
  toast.isActive = toast_store.toastStore.isActive;
  return toast;
}
exports.Toast = Toast;
exports.createRenderToast = createRenderToast;
exports.createToastFn = createToastFn;